import { render, staticRenderFns } from "./WidgetBody.vue?vue&type=template&id=04a26c30&scoped=true&"
import script from "./WidgetBody.vue?vue&type=script&lang=js&"
export * from "./WidgetBody.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBody.vue?vue&type=style&index=0&id=04a26c30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a26c30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04a26c30')) {
      api.createRecord('04a26c30', component.options)
    } else {
      api.reload('04a26c30', component.options)
    }
    module.hot.accept("./WidgetBody.vue?vue&type=template&id=04a26c30&scoped=true&", function () {
      api.rerender('04a26c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/widget-preview/components/WidgetBody.vue"
export default component.exports